import { render } from "./GridHeadAccount.vue?vue&type=template&id=2ce91691"
import script from "./GridHeadAccount.vue?vue&type=script&lang=js"
export * from "./GridHeadAccount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__